import { Col, Row } from '@maternity/mun-layout';
import { Anchor } from '@maternity/mun-router';
import * as React from 'react';

export function ErrorInfo({ msg }: { msg: string }) {
  return (
    <Row>
      <Col xs={12}>
        <p className="error-info">
          {msg}
          <br />
          If you need help, contact us at{' '}
          <Anchor href="mailto:sales@quiltedhealth.com">
            sales@quiltedhealth.com
          </Anchor>
        </p>
      </Col>
    </Row>
  );
}
